module.exports = __webpack_public_path__ + "d04cc537b49296ebee8a693984a36b7c.svg";